module.exports = __webpack_public_path__ + "static/gordon-food-services-31fb649fa1c05cff1e81c1889a064871.jpg";